// extracted by mini-css-extract-plugin
export var actionButton = "_d2-t";
export var buttonContainer = "_d2-0";
export var buttonContainer2 = "_d2-1";
export var buttonSection = "_d2-2";
export var details = "_d2-3";
export var dropdownItem = "_d2-5";
export var dropdownItemsContainer = "_d2-4";
export var fileInput = "_d2-r";
export var headerButton = "_d2-6";
export var icon = "_d2-7";
export var input = "_d2-8";
export var macroListItem = "_d2-9";
export var mainContent = "_d2-a";
export var microText = "_d2-b";
export var modal = "_d2-w";
export var optionsButton = "_d2-c";
export var paperclip = "_d2-s";
export var pillContent = "_d2-d";
export var preview = "_d2-e";
export var preview2 = "_d2-f";
export var quillEditor = "_d2-q";
export var selectedMacro = "_d2-g";
export var sidebar = "_d2-h";
export var sidebarHeader = "_d2-j";
export var sidebarList = "_d2-i";
export var sidebarListItem = "_d2-k";
export var sidebarSearch = "_d2-l";
export var snoozeDurationWrapper = "_d2-v";
export var statusPillContainer = "_d2-m";
export var tagsContainer = "_d2-n";
export var unselectedMacro = "_d2-o";
export var variable = "_d2-u";
export var wrapper = "_d2-p";